import React from "react";
import logo1 from "../../asset/img/team_logo1.png";
import logo2 from "../../asset/img/team_logo2.png";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { momentFormat } from "../lib/dateFormat";
import Loader from "./Loader";
import { getPointGames } from "../actions/gameSettings";
import { formatOdds, formatPoint, formatTotalPoint } from "../../utility/odds";
function TeamCard({
  handleChecked,
  isChecked,
  isSelect,
  teamsSelect,
  selectValue,
}) {
  // const {gameData} = useSelector((state) => state.gameData);
  const [pageLoading, setPageLoading] = useState(false);
  const { oddData, oddMessage } = useSelector((state) => state.oddsData);

  return (
    <div className="team_card">
      {isSelect && oddData ? (
        <div className="mg_table_wrapper">
          <div className="mg_table_card mb-4">
            <div className="mg_table_wrapper table-responsive">
              <table className="table mg_table">
                {oddData?.length > 0 ? (
                  oddData?.map((item, index) => {
                    return (
                      <React.Fragment
                        key={`odd-block-${item?.id ?? item?.sport_key ?? "sport"}-${index}`}>
                        <thead>
                          <tr>
                            <th
                              colSpan={5}
                              className="mg_table_title_secondary">
                              {item?.sport_title}: SPREADS - MONEY LN - TOTALS
                            </th>
                          </tr>
                          <tr className="">
                            <th className="mg_table_title_primary">Date</th>
                            <th className="mg_table_title_primary">Team</th>
                            <th className="mg_table_title_primary">M Line</th>
                            <th className="mg_table_title_primary">Spread</th>
                            <th className="mg_table_title_primary">Total</th>
                          </tr>
                        </thead>

                        {item?.bookmakers?.map((items, i) => {
                          const marketsList = items?.markets || [];
                          const mk = Object.fromEntries(
                            marketsList.map((m) => [m?.key, m])
                          );
                          const ix = (key) =>
                            marketsList.findIndex((m) => m?.key === key);

                          return (
                            <React.Fragment key={`odd-bm-${item?.id ?? item?.sport_key}-${i}`}>
                              <tbody className="mg_table_body odd">
                                <tr>
                                  <td
                                    colSpan={5}
                                    className="mg_table_title_third">
                                    Bookmakers: {items?.title}
                                  </td>
                                </tr>
                                <tr className="mg_gray_row ">
                                  <td>
                                    <p className="mb-0">
                                      {momentFormat(item?.commence_time)}
                                    </p>
                                  </td>
                                  <td>{item?.home_team}</td>
                                  <td>
                                    {mk["h2h"] && (
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          type="checkbox"
                                          id={ix("h2h")}
                                          onChange={(e) => {
                                            const market = mk["h2h"];
                                            const index = ix("h2h");
                                            let teamObj = {
                                              teamName: item.home_team,
                                              homeTeam: item.home_team,
                                              awayTeam: item.away_team,
                                              type: market?.key,
                                              price: market?.outcomes[0]?.price,
                                              sport_key: item.sport_key,
                                              sport_title: item.sport_title,
                                              gameTime: item.commence_time,
                                              id: item.id,
                                              CheckId: `${i}${index}`,
                                            };
                                            teamsSelect(e, teamObj);
                                          }}
                                          checked={selectValue?.find(
                                            (val) =>
                                              val.teamName == item.home_team &&
                                              val.CheckId == `${i}${ix("h2h")}`
                                          )}
                                        />
                                        <p className="mb-0">
                                          {formatOdds(mk["h2h"]?.outcomes[0]?.price)}
                                        </p>
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    {mk["spreads"] && (
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          className="mt-1 mt-md-0"
                                          type="checkbox"
                                          id={ix("spreads")}
                                          onChange={(e) => {
                                            const market = mk["spreads"];
                                            const index = ix("spreads");
                                            let teamObj = {
                                              teamName: item.home_team,
                                              homeTeam: item.home_team,
                                              awayTeam: item.away_team,
                                              type: market?.key,
                                              price: market?.outcomes[0]?.price,
                                              point: market?.outcomes[0]?.point,
                                              sport_key: item.sport_key,
                                              sport_title: item.sport_title,
                                              gameTime: item.commence_time,
                                              id: item.id,
                                              CheckId: `${i}${index}`,
                                            };
                                            teamsSelect(e, teamObj);
                                          }}
                                          checked={selectValue?.find(
                                            (val) =>
                                              val.teamName == item.home_team &&
                                              val.CheckId ==
                                                `${i}${ix("spreads")}`
                                          )}
                                        />
                                        <p className="mb-0">
                                          {formatPoint(mk["spreads"]?.outcomes[0]?.point)}{" "}
                                          {formatOdds(mk["spreads"]?.outcomes[0]?.price)}{" "}
                                          {mk["spreads"]?.outcomes[0]?.point}
                                        </p>
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    {mk["totals"] && (
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          className="mt-1 mt-md-0"
                                          type="checkbox"
                                          id={ix("totals")}
                                          onChange={(e) => {
                                            const market = mk["totals"];
                                            const index = ix("totals");
                                            let teamObj = {
                                              teamName: item.home_team,
                                              homeTeam: item.home_team,
                                              awayTeam: item.away_team,
                                              type: market?.key,
                                              pointType:
                                                market?.outcomes[0]?.name,
                                              price: market?.outcomes[0]?.price,
                                              point: market?.outcomes[0]?.point,
                                              sport_key: item.sport_key,
                                              sport_title: item.sport_title,
                                              gameTime: item.commence_time,
                                              id: item.id,
                                              CheckId: `${i}${index}`,
                                            };
                                            teamsSelect(e, teamObj);
                                          }}
                                          checked={selectValue?.find(
                                            (val) =>
                                              val.teamName == item.home_team &&
                                              val.CheckId ==
                                                `${i}${ix("totals")}`
                                          )}
                                        />
                                        <p className="mb-0">
                                          {formatTotalPoint(
                                            mk["totals"]?.outcomes[0]?.point,
                                            mk["totals"]?.outcomes[0]?.name
                                          )}{" "}
                                          {formatOdds(mk["totals"]?.outcomes[0]?.price)}
                                        </p>
                                      </div>
                                    )}
                                  </td>
                                </tr>

                                <tr className="mg_gray_row">
                                  <td>
                                    <p className="mb-0">
                                      {momentFormat(item?.commence_time)}
                                    </p>
                                  </td>
                                  <td>{item?.away_team}</td>
                                  <td>
                                    {mk["h2h"] && (
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          type="checkbox"
                                          id={ix("h2h")}
                                          onChange={(e) => {
                                            const market = mk["h2h"];
                                            const index = ix("h2h");
                                            let teamObj = {
                                              teamName: item.away_team,
                                              homeTeam: item.home_team,
                                              awayTeam: item.away_team,
                                              type: market?.key,
                                              price: market?.outcomes[1]?.price,
                                              sport_key: item.sport_key,
                                              sport_title: item.sport_title,
                                              gameTime: item.commence_time,
                                              id: item.id,
                                              CheckId: `${i}${index}`,
                                            };
                                            teamsSelect(e, teamObj);
                                          }}
                                          checked={selectValue?.find(
                                            (val) =>
                                              val.teamName == item.away_team &&
                                              val.CheckId == `${i}${ix("h2h")}`
                                          )}
                                        />
                                        <p className="mb-0">
                                          {formatOdds(mk["h2h"]?.outcomes[1]?.price)}
                                        </p>
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    {mk["spreads"] && (
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          type="checkbox"
                                          id={ix("spreads")}
                                          onChange={(e) => {
                                            const market = mk["spreads"];
                                            const index = ix("spreads");
                                            let teamObj = {
                                              teamName: item.away_team,
                                              homeTeam: item.home_team,
                                              awayTeam: item.away_team,
                                              type: market?.key,
                                              price: market?.outcomes[1]?.price,
                                              point: market?.outcomes[1]?.point,
                                              sport_key: item.sport_key,
                                              sport_title: item.sport_title,
                                              gameTime: item.commence_time,
                                              id: item.id,
                                              CheckId: `${i}${index}`,
                                            };
                                            teamsSelect(e, teamObj, index);
                                          }}
                                          checked={selectValue?.find(
                                            (val) =>
                                              val.teamName == item.away_team &&
                                              val.CheckId ==
                                                `${i}${ix("spreads")}`
                                          )}
                                        />
                                        <p className="mb-0">
                                          {formatPoint(mk["spreads"]?.outcomes[1]?.point)}{" "}
                                          {formatOdds(mk["spreads"]?.outcomes[1]?.price)}{" "}
                                          {mk["spreads"]?.outcomes[1]?.point}
                                        </p>
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    {mk["totals"] && (
                                      <div className="d-flex align-items-center gap-2">
                                        <input
                                          className="mt-1 mt-md-0"
                                          type="checkbox"
                                          id={ix("totals")}
                                          onChange={(e) => {
                                            const market = mk["totals"];
                                            const index = ix("totals");
                                            let teamObj = {
                                              teamName: item.away_team,
                                              homeTeam: item.home_team,
                                              awayTeam: item.away_team,
                                              type: market?.key,
                                              pointType:
                                                market?.outcomes[1]?.name,
                                              price: market?.outcomes[1]?.price,
                                              point: market?.outcomes[1]?.point,
                                              sport_key: item.sport_key,
                                              sport_title: item.sport_title,
                                              gameTime: item.commence_time,
                                              id: item.id,
                                              CheckId: `${i}${index}`,
                                            };
                                            teamsSelect(e, teamObj);
                                          }}
                                          checked={selectValue?.find(
                                            (val) =>
                                              val.teamName == item.away_team &&
                                              val.CheckId ==
                                                `${i}${ix("totals")}`
                                          )}
                                        />
                                        <p className="mb-0">
                                          {formatTotalPoint(
                                            mk["totals"]?.outcomes[1]?.point,
                                            mk["totals"]?.outcomes[1]?.name
                                          )}{" "}
                                          {formatOdds(mk["totals"]?.outcomes[1]?.price)}
                                        </p>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </React.Fragment>
                          );
                        })}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <span>
                    {oddMessage}
                  </span>
                )}
              </table>
            </div>
          </div>
        </div>
      ) : (
        <Loader></Loader>
      )}
    </div>
  );
}

export default TeamCard;
